// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import HeardIslandAndMcdonaldIslands from '../_raw/flag/icon_flag_heard_island_and_mcdonald_islands.png';

export default () => (
  <img src={HeardIslandAndMcdonaldIslands} alt="HeardIslandAndMcdonaldIslands" />
);
